import {store} from 'store';

export function forbid(event, form) {
  store.dispatch({
    type: 'UI_DISPLAY_MODAL',
    id: 'Upgrade'
  });
  if (event && event.preventDefault) {
    event.preventDefault();
  }
  if (form && form.resetForm) {
    form.resetForm();
  }
}
